import { InputAdornment } from '@mui/material';

import { IconSearchMS } from '../../../constants/icons';
import { StyledInputBase } from './styles';

interface SearchProps {
  searchField: string;
  setSearchField: (value: string) => void;
}

export function Search({
  searchField,
  setSearchField,
}: SearchProps): JSX.Element {
  return (
    <StyledInputBase
      placeholder="Pesquisar"
      inputProps={{ 'aria-label': 'pesquisar', maxLength: 11 }}
      type="search"
      value={searchField}
      startAdornment={
        <InputAdornment
          position="start"
          sx={(theme) => ({
            color: theme.palette.secondary.main,
          })}
        >
          {IconSearchMS}
        </InputAdornment>
      }
      onChange={(e) => {
        if (e.target.value.length > 0) {
          setSearchField(e.target.value);
        }
        if (e.target.value.length === 0) {
          setSearchField('');
        }
      }}
      onFocus={(e) => {
        e.target.value = '';
        setSearchField('');
      }}
    />
  );
}
